// extracted by mini-css-extract-plugin
module.exports = {"friends":"Friends_friends__zD8o6","showMe":"Friends_showMe__3Quvb","loadMore":"Friends_loadMore__6HARf"};